"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getStyles = (0, _memoize2["default"])(function (customStyles, isMobile) {
  return {
    singleValue: function singleValue(base, state) {
      var _customStyles$singleV;

      return _objectSpread(_objectSpread({}, base), {}, {
        fontSize: 16,
        lineHeight: '20px',
        textOverflow: 'clip',
        fontWeight: state.selectProps.menuIsOpen ? 400 : 600,
        color: state.selectProps.menuIsOpen ? '#d6d5c9' : '#17181a'
      }, (_customStyles$singleV = customStyles.singleValue) === null || _customStyles$singleV === void 0 ? void 0 : _customStyles$singleV.call(customStyles, base, state));
    },
    control: function control(base, state) {
      var _customStyles$control;

      var height = isMobile ? 40 : 45;
      var borderRadius = isMobile ? 6 : 0;
      var boxShadow = isMobile ? 'inset 0 0 0 1px #d6d5c3' : '';
      var onHover = {
        cursor: 'pointer'
      };
      return _objectSpread(_objectSpread({}, base), {}, {
        position: 'relative',
        border: 0,
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        '&:hover': onHover,
        height: height
      }, (_customStyles$control = customStyles.control) === null || _customStyles$control === void 0 ? void 0 : _customStyles$control.call(customStyles, base, state));
    },
    option: function option(base, state) {
      var _customStyles$option;

      return _objectSpread(_objectSpread({}, base), {}, {
        color: 'black',
        '&:hover': {
          backgroundColor: '#e6f2ff',
          cursor: 'pointer'
        },
        backgroundColor: state.isFocused ? '#e6f2ff' : '#ffffff'
      }, (_customStyles$option = customStyles.option) === null || _customStyles$option === void 0 ? void 0 : _customStyles$option.call(customStyles, base, state));
    },
    menu: function menu(base, state) {
      var _customStyles$menu;

      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      }, (_customStyles$menu = customStyles.menu) === null || _customStyles$menu === void 0 ? void 0 : _customStyles$menu.call(customStyles, base, state));
    },
    menuList: function menuList(base, state) {
      var _customStyles$menuLis;

      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999,
        padding: 0
      }, (_customStyles$menuLis = customStyles.menuList) === null || _customStyles$menuLis === void 0 ? void 0 : _customStyles$menuLis.call(customStyles, base, state));
    },
    valueContainer: function valueContainer(base, state) {
      var _customStyles$valueCo;

      return _objectSpread(_objectSpread({}, base), (_customStyles$valueCo = customStyles.valueContainer) === null || _customStyles$valueCo === void 0 ? void 0 : _customStyles$valueCo.call(customStyles, base, state));
    }
  };
});
exports.getStyles = getStyles;